import axios, { AxiosResponse } from 'axios';
import { resolve } from './resolve.js';
import {API_BACKEND_URL} from "../constants/consts";
import {getExchangeHeaders} from "./helpers";


export type addToCardParams = {
    product_id: number;
    quantity: number;
    currency_id: number;
}


export async function fetchGetActiveUserProductCart(): Promise<AxiosResponse["data"]>  {
    return await resolve(axios.get(`${API_BACKEND_URL}/carts/active_cart`,
        {
            headers: getExchangeHeaders(),
        }
    ).then(res => res));
}

export async function addProductToUserActiveCart(productParams: addToCardParams, sum_quant=false): Promise<AxiosResponse["data"]> {
    return await resolve(axios.post(`${API_BACKEND_URL}/carts/add_or_create?sum_quant=${sum_quant}`,
            productParams, {
            headers: getExchangeHeaders(),
        }


    ).then(res => res));
}

export async function deleteCartLinesInUserActiveCart(deleteParams: { ids: number[]; }): Promise<AxiosResponse["data"]> {
    return await resolve(axios.post(`${API_BACKEND_URL}/carts/cartlines/delete_cartlines`,
        deleteParams,{
            headers: getExchangeHeaders(),
        }
    ).then(res => res));
}

export async function changeValueInProduct(productId: number, productParams: { quantity: number; }): Promise<AxiosResponse["data"]> {
    return await resolve(axios.patch(`${API_BACKEND_URL}/carts/cartline/product/${productId}`,
        productParams,{
            headers: getExchangeHeaders(),
        }


    ).then(res => res));
}

// export async function createBackendSaleOrder(data: { order_line: any; }){
//     return await resolve(axios.post(`${API_BACKEND_URL}/sales`,
//         data,{
//             headers: getExchangeHeaders(),
//         }
//
//
//     ).then(res => res));
// }

export async function createBackendSaleOrder(data: { order_line: any; }): Promise<AxiosResponse["data"]> {
    return await resolve(axios.post(`${API_BACKEND_URL}/sales/`,
        data,{
            headers: getExchangeHeaders(),
        }


    ).then(res => res));
}

export type PortalOrderPayload = {
    order_line: any;
    responsible?: string | null;
    customer_name?: string;
    company_type?: string;
    phone?: string;
    email?: string;
    city?: string;
    postal_code?: string;
    address?: string;
    countryId?: number;
    addressId?: number;
    isDropshipping?: boolean;
    comment?: string;
    is_b2b_active?: boolean;
};

const PORTAL_ORDER_REQUEST_TIMEOUT = 15000;

export const createPortalOrderRequestKey = () =>
    globalThis.crypto?.randomUUID?.() ??
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export async function createBackendSaleOrderFromReserve(
    data: PortalOrderPayload,
    requestKey: string = createPortalOrderRequestKey(),
): Promise<AxiosResponse["data"]> {
    return await resolve(axios.post(`${API_BACKEND_URL}/sales/create_order_from_reserve`,
            data,{
            headers: {
                ...getExchangeHeaders(),
                "Idempotency-Key": requestKey,
            },
            timeout: PORTAL_ORDER_REQUEST_TIMEOUT,
        }
    ).then(res => res));
}

export async function createBackendSaleOrderFromPreorder(
    data: PortalOrderPayload,
    requestKey: string = createPortalOrderRequestKey(),
): Promise<AxiosResponse["data"]> {
    return await resolve(axios.post(`${API_BACKEND_URL}/sales/create_order_from_preorder`,
            data,{
            headers: {
                ...getExchangeHeaders(),
                "Idempotency-Key": requestKey,
            },
            timeout: PORTAL_ORDER_REQUEST_TIMEOUT,
        }
    ).then(res => res));
}

export async function deleteProductInUserActiveCart(deleteParams: { product_ids: number[]; }): Promise<AxiosResponse["data"]> {
    return await resolve(axios.post(`${API_BACKEND_URL}/carts/cartlines/delete_cartlines_by_product_ids`,
        deleteParams,{
            headers: getExchangeHeaders(),
        }


    ).then(res => res));
}
